import api from '@/shared/utils/apiConfig';
import type { OrgEntitlements } from '@/shared/billing/planCatalog';
import type { TreatmentRecordingMode } from '@/shared/config/treatmentRecordingMode';

export interface ProfileUserData {
  id?: string;
  _id?: string;
  name: string;
  email?: string;
  phone?: string;
  username?: string;
  role: string;
  /** Permission group display name from GET /auth/me. Null for admin. */
  permissionGroupName?: string | null;
  lastLoginAt?: string;
  staffId?: string | null;
  gender?: 'male' | 'female' | 'other';
  /** Relative `/api` path for AppBar/profile avatar. */
  avatar?: string | null;
  staff?: {
    id: string;
    firstName?: string;
    lastName?: string;
    gender?: 'male' | 'female' | 'other';
    avatarUrl?: string | null;
    staffCode?: string;
    email?: string;
    phone?: string;
    department?: string | { id?: string; code?: string; name?: string };
    designation?: string;
    status?: string;
    isDoctor?: boolean;
    isAssistant?: boolean;
    primaryClinics?: string[];
  } | null;
  twoFactorEnabled?: boolean;
  entitlements?: OrgEntitlements;
  treatmentRecordingMode?: TreatmentRecordingMode;
}

export interface ChangePasswordPayload {
  currentPassword: string;
  newPassword: string;
}

export const profileAPI = {
  getMe: async (): Promise<ProfileUserData> => {
    const response = await api.get<{ data: ProfileUserData }>('/auth/me');
    return response.data.data;
  },

  changePassword: async (payload: ChangePasswordPayload): Promise<void> => {
    await api.put('/auth/change-password', payload);
  },
};
